module.exports = __webpack_public_path__ + "static/a-most-wanted-man-2fd19b3912fe3b40c6709e0534e299d0.jpg";